import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule } from '@angular/forms';
import { ChangePasswordModalComponent } from './components/change-password-modal/change-password-modal.component';


@NgModule({
  declarations: [
    ChangePasswordModalComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule
  ],
  exports: [
    ChangePasswordModalComponent
  ],
  entryComponents: [
    ChangePasswordModalComponent
  ]
})
export class ChangePasswordUserModule { }
